import { NewFeaturedHazardDataRequest } from "@/dataModel/requests";

export class ModifyFeaturedHazardDataRequest {
  featuredHazardData: NewFeaturedHazardDataRequest[];

  constructor(featuredHazardData?: NewFeaturedHazardDataRequest[]) {
    this.featuredHazardData = featuredHazardData || [];
  }
}
